import { Events } from '@setplex/pureya'
import { createEvent, sample } from 'effector'
import { and, interval } from 'patronum'
import { model as config, remote } from '~/shared/config'
import { ONE_SECOND_MS } from '~/shared/constants/time'
import { model as mq, PLAYER } from '~/shared/mq'
import { playStart, playStop } from './play-start-stop'

const $enabled = config.get(remote.tria_isTrackAnalyticsStreamInfoEventEnabled)
const $interval = config
  .get(remote.tria_analyticsStreamInfoEventIntervalSeconds)
  .map((seconds) => seconds * ONE_SECOND_MS || 10_000) // convert to ms, default to 10s if invalid value provided

export const streamInfo = createEvent()

export const transmittedBytes = mq.on<{
  playerId: string
  payload: Events.Media.TransmittedBytesInfo
}>(`${PLAYER}/${Events.Media.TransmittedBytesInfo}`)

const start = createEvent()
const stop = createEvent()

sample({
  clock: playStart,
  filter: ({ snapshot: p }) => !p?.httpErrorCode && !p?.contentErrorCode, // don't start if there are any errors
  target: start,
})

sample({
  clock: playStop,
  filter: ({ reason }) => reason !== 'streamBuffering', // don't stop on buffering
  target: stop,
})

const { tick: collect, isRunning: $running } = interval({
  timeout: $interval,
  start: start,
  stop: stop,
  leading: false,
  trailing: false,
})

sample({
  clock: collect,
  filter: and($enabled, $running),
  target: streamInfo,
})
